<script setup>
const langActive = ref(false)
const localePath = useLocalePath()
const router = useRouter()
const { t, setLocale, locale } = useI18n()
const currentLang = ref(locale)
async function changeLocale(event) {
  setLocale(event)
  currentLang.value = event
  await navigateTo(localePath(useRoute().path))

  setTimeout(() => {
    location.reload()
  }, 1200)
}
function openLang() {
  langActive.value = true
}
function closeLang() {
  langActive.value = false
}
</script>

<template>
  <div @mouseover="openLang" @mouseleave="closeLang">
    <div
      class="navigation group hidden items-center gap-1.5 lg:flex"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg" class="text-primary group-hover:text-secondary-red-100" width="18" height="18"
        viewBox="0 0 24 24"
      >
        <g fill="none">
          <circle
            cx="12" cy="12" r="9" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
            stroke-width="2"
          />
          <path
            fill="currentColor"
            d="M8 6V4c2.5-1.167 8.4-2 12 4h-1a2 2 0 0 0-2 2a2 2 0 1 1-4 0a2 2 0 0 0-2-2h-1a2 2 0 0 1-2-2zm9 10h3c-1.2 1.6-3.833 3.333-5 4v-2a2 2 0 0 1 2-2zm-6 2v2c-6.4-.4-8-5.5-8-8h2a2 2 0 0 1 2 2a2 2 0 0 0 2 2a2 2 0 0 1 2 2z"
          />
          <path
            stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M8 6V4c2.5-1.167 8.4-2 12 4h-1a2 2 0 0 0-2 2a2 2 0 1 1-4 0a2 2 0 0 0-2-2h-1a2 2 0 0 1-2-2zm9 10h3c-1.2 1.6-3.833 3.333-5 4v-2a2 2 0 0 1 2-2zm-6 2v2c-6.4-.4-8-5.5-8-8h2a2 2 0 0 1 2 2a2 2 0 0 0 2 2a2 2 0 0 1 2 2z"
          />
        </g>
      </svg>
      <div class="text-sm font-medium group-hover:text-secondary-red-100">
        <span v-if="locale === 'en'">EN</span>
        <span v-else>TH</span>
      </div>
      <svg :class="langActive ? 'rotate-180' : ''" class="h-4 w-4 transition-all ease" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m19 9l-7 6l-7-6" /></svg>
    </div>
    <div
      class="flex cursor-pointer border border-primary rounded-md p-1 text-[8px] font-semibold lg:hidden"
    >
      <div v-if="locale === 'en'" class="text-primary font-bold" @click="changeLocale('th')">
        EN
      </div>
      <div v-if="locale === 'th'" class="text-primary font-bold" @click="changeLocale('en')">
        TH
      </div>
    </div>
    <transition
      enter-active-class="transition duration-200 ease-out"
      enter-from-class="transform scale-95 opacity-0" enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-150 ease-in" leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0"
    >
      <div v-if="langActive" class="absolute right-0 top-0 z-50 mt-3 hidden translate-x-[50%] transform lg:flex sm:translate-x-0">
        <div
          class="flex translate-y-5 items-center whitespace-nowrap rounded-md shadow-custom-2xl shadow-shadow-light/20"
        >
          <div
            class="flex flex-col cursor-pointer text-sm font-semibold"
          >
            <div
              :class="locale === 'en' ? '!bg-blue-100' : 'bg-white'"
              class="hocver:text-white flex items-center gap-2 rounded-tl-md rounded-tr-md px-4 py-2 text-primary hover:!bg-blue-200"
              @click="changeLocale('en')"
            >
              <IconFlagUS class="h-5 w-5" />
              EN
            </div>
            <hr class="border-secondary-grey-300/60">
            <div
              :class=" locale === 'th' ? '!bg-blue-100' : 'bg-white'"
              class="hocver:text-white flex items-center gap-2 rounded-bl-md rounded-br-md bg-white px-4 py-2 text-primary hover:!bg-blue-200"
              @click="changeLocale('th')"
            >
              <IconFlagTH class="h-5 w-5" />
              TH
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
